<script setup lang="ts">
import {DiscussReply} from "@/types";
import {TimeFormatter} from "@/utils/common.ts";
import {ElNotification} from "element-plus";

const props = defineProps<{
  reply: DiscussReply
}>()

const emit = defineEmits(['onReply', 'onDelete'])

const onReply = () => {
  emit("onReply", props.reply.id)
}

const onDelete = () => {
  emit("onDelete", props.reply.id)
}

const showWarning = () => {
  ElNotification.info({
    message: '暂不支持PC端点赞,请使用移动端~',
  })
}
</script>

<template>
  <div class="flex mt-1rem">
    <el-avatar size="small" :src="reply.head_img"></el-avatar>
    <div class="ml-.75rem">
      <div class="mt-.25rem">
        <span>
         {{ reply.user_name }}
        </span>
        回复
        <span v-if="reply.reply_name">
         {{ reply.reply_name.user_name }}
        </span>
        :
        {{ reply.content }}
      </div>
      <div class="flex items-center mt-.5rem">
        <div class="text-.85em text-[rgba(0,0,0,0.251)] mr-4rem">{{
            TimeFormatter.formatTime(reply.create_time * 1000)
          }}
        </div>
        <div class="flex gap-.25rem mr-2rem items-center cursor-pointer" @click="showWarning">
          <img src="@/assets/image/icon/icon-praise.png" class="w-1rem h-1rem" alt="icon-praise"/>
          <div class="text-.75em text-[rgba(0,0,0,0.251)] mt-2px">{{ reply.like_num }}</div>
        </div>
        <div class="flex gap-.25rem mr-2rem items-center cursor-pointer" @click="onReply">
          <img src="@/assets/image/icon/icon-reply.png" class="w-1rem h-1rem" alt="icon-reply"/>
          <div class="text-.75em text-[rgba(0,0,0,0.251)] mt-2px">回复</div>
        </div>
        <div class="flex gap-.25rem items-center cursor-pointer" @click="onDelete">
          <img src="@/assets/image/icon/icon-delete.png" class="w-1rem h-1rem" alt="icon-reply"/>
          <div class="text-.75em text-[rgba(0,0,0,0.251)] mt-2px">删除</div>
        </div>
      </div>
    </div>

  </div>
</template>

<style scoped>
</style>
